import * as constants from './constants';

export const getSets = (payload) => ({ type: constants.GET_SETS, payload });
export const getSetsSuccess = (payload) => ({ type: constants.GET_SETS_SUCCESS, payload });
export const getSetsError = (payload) => ({ type: constants.GET_SETS_ERROR, payload });

export const clearSets = () => ({ type: constants.CLEAR_SETS });
